<template>
    <ul>
        <li v-for="row in table_rows">
            <router-link :to="'/' + (row.manager_type == 'Agency' ? 'agencies' : 'agents') + '/view/'+row.manager_id">{{ row.manager_name }}</router-link> manages {{ row.seller_name }} <span v-if="row.commission">at {{ row.commission }}</span>
        </li>
    </ul>
</template>

<script>
    export default {
        props: ['columns', 'data'],

        data() {
            return {
                hierarchy: null,
                max_level: null,
                table_rows: null,
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {
            getHierarchy(){
                //Send it
                this.$http.get('/reports/hierarchy/'+this.data.id)
                    .then(response => {
                        //Setter
                        this.hierarchy = response.data.hierarchy;
                        this.max_level = response.data.max_level;
                        this.table_rows = response.data.table_rows;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            }
        },

        mounted() {
            //Get it
            this.getHierarchy();
        }
    }
</script>
